import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import {
  Container,
  Box,
  Button,
  Typography,
  Grid,
  Stack,
  Pagination,
  useTheme,
  useMediaQuery,
  Tabs,
  Tab,
  Divider
} from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import FormTextField from "../form/FormTextField";
import { setAlert } from "../../features/slices/alertSlice";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import * as Constant from "../../features/constant";
import { DataGrid } from "@mui/x-data-grid";
import format from "date-fns/format";
import { lighten } from "@material-ui/core";
import Image from "../common/Image";
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import PaidIcon from '@mui/icons-material/Paid';
import ErrorIcon from '@mui/icons-material/Error';
import { FocusTrap } from '@mui/base/FocusTrap';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

const Withdrawal = ({ withdrawDetails, useWithdrawMutation, user, useGetHistoryMutation, useGetBankAccountsQuery, useGetPromotionRecordMutation, setSelectedScreen }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const { t } = useTranslation();
  const mobileView = useMediaQuery(theme.breakpoints.down("sm"));
  const currentDate = new Date();
  const sevenDaysAgo = new Date();
  const [open, setOpen] = React.useState(false);
  const [bankAccountName, setBankAccountName] = React.useState('');
  const [bankCode, setBankCode] = React.useState('');
  const [bankAccountNumber, setBankAccountNumber] = React.useState('');
  const [selectedBank, setSelectedBank] = useState(0);

  const type = [
    { label: t("walletcard.transactionpage.all"), value: "All" },
    { label: t("walletcard.transactionpage.approved"), value: "Approved" },
    { label: t("walletcard.transactionpage.rejected"), value: "Rejected" },
    { label: t("walletcard.transactionpage.pending"), value: "Pending" },
  ];

  const [statusType, setStatusType] = useState(type[0].value);
  const [startDate, setStartDate] = useState(
    sevenDaysAgo.setDate(currentDate.getDate() - 7)
  );
  const [endDate, setEndDate] = useState(currentDate);
  const [offset, setOffset] = useState(0);

  const {
    data: bankDetails,
    isLoading: isBankDetailsLoading,
    isError: isBankDetailsError,
    isSuccess: isBankDetailsSuccess,
    error: bankDetailsError,
  } = useGetBankAccountsQuery();

  const [
    promotionRecord,
    result,
    // { data, isLoading, isError, isSuccess, error },
  ] = useGetPromotionRecordMutation();

  useEffect(() => {
    if (!(endDate < startDate)) {
      let data = {
        criteria: {
          dateFrom: format(startDate, "dd-MM-yyyy"),
          dateTo: format(endDate, "dd-MM-yyyy"),
          status: statusType.toUpperCase(),
        },
        offset: offset,
      };
      promotionRecord(data).unwrap();
    }
  }, [startDate, endDate, statusType, offset]);


  React.useEffect(() => {
    if (isBankDetailsSuccess && bankDetails?.result?.data[0]?.bankAccountName) {
      setBankAccountName(bankDetails.result.data[0].bankAccountName);
      setBankCode(bankDetails.result.data[0].bankCode);
      setBankAccountNumber(bankDetails.result.data[0].bankAccountNumber);
    }
  }, [isBankDetailsSuccess, bankDetails]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (bankDetails, index) => {
    setOpen(false);
    if (bankDetails !== null && bankDetails !== undefined) {
      setBankAccountName(bankDetails?.bankAccountName);
      setBankCode(bankDetails?.bankCode);
      setBankAccountNumber(bankDetails?.bankAccountNumber);
      setSelectedBank(index);
    }
  };

  function SimpleDialog(props) {
    const { onClose, bankAccountName, open } = props;

    const handleClose = () => {
      onClose(bankAccountName, null);
    };

    const handleListItemClick = (bankDetails, index) => {
      onClose(bankDetails, index);
    };
    return (
      <Dialog onClose={handleClose} open={open} sx={{
        "& .MuiPaper-root": {
          bgcolor: theme.palette.background.paper,
          width: "100%",
          margin: 0,
          maxHeight: "100%",
          marginX: 2
        }
      }}>
        <DialogTitle sx={{ color: 'white' }} >{t("walletcard.withdrawalpage.selectbank")}</DialogTitle>
        <List sx={{ pt: 0, marginX: 3 }}>
          {bankDetails?.result?.data?.map((data, index) => (
            <ListItem disableGutters key={data?.bankCode}>
              <ListItemButton onClick={() => handleListItemClick(data, index)} sx={{
                border: `1px solid ${index === selectedBank ? theme.palette.primary.main : '#ccc'}`,
                borderRadius: '5px',
                padding: '10px'
              }}>
                <div sx={{ display: 'flex', flexDirection: 'column' }}>
                  <ListItemText
                    primary={<><b>{t('walletcard.withdrawalpage.bankaccountnumber')}: </b>{data?.bankAccountNumber}</>}
                    primaryTypographyProps={{
                      sx: { color: 'white', fontSize: mobileView ? '13px' : '16px' }
                    }}
                  />
                  <ListItemText
                    primary={<><b>{t('walletcard.withdrawalpage.bankaccountname')}: </b> {data?.bankAccountName}</>}
                    primaryTypographyProps={{
                      sx: { color: 'white', fontSize: mobileView ? '13px' : '16px' }
                    }}
                  />
                  <ListItemText
                    primary={
                      <>
                        <b>{t('walletcard.withdrawalpage.bankname')}: </b>
                        {data?.bankCode}
                      </>
                    }
                    primaryTypographyProps={{
                      sx: { color: 'white', fontSize: mobileView ? '13px' : '16px' }
                    }}
                  />
                </div>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Dialog>
    );
  }


  const [openStates, setOpenStates] = useState(Array(result?.data?.result?.content.length).fill(false));

  const toggleOpenState = (index) => {
    setOpenStates(prevStates => {
      const newStates = [...prevStates];
      newStates[index] = !newStates[index];
      return newStates;
    });
  };
  
  const hasMaxWithdraw =
    user?.maxWithdraw != null && !isNaN(user.maxWithdraw) && user.maxWithdraw > 0;

  const maxAmount = hasMaxWithdraw
    ? user.maxWithdraw
    : user?.currentCredit;

  const hasValidMax = maxAmount != null && !isNaN(maxAmount) && maxAmount > 0;

  let amountSchema = yup
    .number()
    .typeError(t("validation.amountonly"))
    .required(t("validation.amountisrequired"));

  if (hasValidMax) {
    amountSchema = amountSchema.max(
      maxAmount,
      `${t("validation.maxallowed")} ${maxAmount}`
    );
  }

  if (!hasMaxWithdraw) {
    amountSchema = amountSchema.min(
      withdrawDetails?.withdrawalDetails?.minimum,
      `Min ${withdrawDetails?.withdrawalDetails?.minimum}`
    );
  }

  const withdrawalSchema = yup.object().shape({
    bankCode: yup.string().required(t("validation.bankname")),
    bankAccountName: yup.string().required(t("validation.bankaccname")),
    bankAccountNo: yup.string().required(t("validation.bankaccno")),
    amount: amountSchema,
  });

  const { control, handleSubmit, reset, getValues } = useForm({
    resolver: yupResolver(withdrawalSchema),
  });

  const [withdraw, { data, isLoading, isError, isSuccess, error }] =
    useWithdrawMutation();

  const [showWithdrawalComponents, setShowWithdrawalComponents] = useState(false);


  const category = [
    { label: t("walletcard.transactionpage.deposit"), value: "Deposit" },
    { label: t("walletcard.transactionpage.withdraw"), value: "Withdraw" },
  ];

  const withdrawalLimit = [
    { label: 'Minimum Amount', value: process.env.REACT_APP_CURRENCY_CODE + ' ' + withdrawDetails?.withdrawalDetails?.minimum },
    { label: 'Maximum Amount', value: process.env.REACT_APP_CURRENCY_CODE + ' ' + withdrawDetails?.withdrawalDetails?.maximum },
    { label: 'Daily Maximum Amount', value: process.env.REACT_APP_CURRENCY_CODE + ' ' + withdrawDetails?.withdrawalDetails?.daily_amt },
    { label: 'Daily Limit', value: withdrawDetails?.withdrawalDetails?.daily_limit + ' Times' },

    // Add more data as needed
  ];

  const [tabValue, setTabValue] = useState(0);

  const withdrawalType = [];
  withdrawalType.push({ label: t("walletcard.depositpage.title") });
  const handleWithdrawButtonClick = () => {
    // Set the state to true to show the Grid container and TabPanel
    setShowWithdrawalComponents(true);
  };

  const handlePageChange = (e, p) => {
    setOffset(p - 1);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: !mobileView ? 3 : 0, mt: !mobileView ? undefined : 3 }}>{children}</Box>}
      </div>
    );
  };

  const WithdrawalContent = ({ t, mobileView, showWithdrawalComponents }) => {
    if (mobileView) {
      if (showWithdrawalComponents) {
        return null;
      }
    }
    return (
      <>
        <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || "white"} paddingTop="3px">
          {t("walletcard.withdrawalConditions")}
        </Typography>
        <Box
          border={1}
          borderRadius={1}
          padding={1}
          borderColor='#838383' // Customize border color as needed
          width={mobileView ? '70%' : '40%'} // Adjust padding for mobile
        >
          <Grid container spacing={1} alignItems="center">
            <Grid item>
              <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="13px">{t("walletcard.withdrawalpage.weeklyTurnOver")} :</Typography>
            </Grid>
            <Grid item>
              <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || "white"} align="right" fontSize="14px">
                {process.env.REACT_APP_CURRENCY_CODE} {withdrawDetails?.playerTurnOver?.weeklyTurnOver || '0.00'}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={1} alignItems="center">
            <Grid item>
              <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="14px">{t("walletcard.withdrawalpage.monthlyTurnOver")} :</Typography>
            </Grid>
            <Grid item>
              <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || "white"} align="right" fontSize="14px">
                {process.env.REACT_APP_CURRENCY_CODE} {withdrawDetails?.playerTurnOver?.monthlyTurnOver || '0.00'}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </>
    );
  };

  const submitWithdrawal = async (data) => {

    let newData = {
      amount: data.amount,
      bankAccountName: bankAccountName,
      bankAccountNumber: bankAccountNumber,
      bankCode: bankCode,
    };

    await withdraw(newData).unwrap();
    navigate(Constant.getPath('/'));
  };

  useEffect(() => {
    if (!isLoading && isSuccess) {
      dispatch(
        setAlert({
          isOpen: true,
          message: t("walletcard.withdrawalpage.successmessage"),
          variant: "success",
        })
      );
      // window.fbq('trackCustom', 'CompleteWithdrawal');
      reset();
    }
    if (!isLoading && isError) {
      dispatch(
        setAlert({
          isOpen: true,
          message: error?.data?.message,
          variant: "error",
        })
      );
      reset();
    }
  }, [isLoading, isSuccess, isError]);

  return (
    <Container>

      <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || "white"}>
        {" "}
        {t("WITHDRAWAL")}
      </Typography>
      <WithdrawalContent
        showWithdrawalComponents={showWithdrawalComponents}
        mobileView={mobileView}
        t={t}
      />
      {!mobileView && (
        <>
          <Box sx={{ height: 400, width: "100%", mt: "30px" }}>
            <DataGrid
              sx={{
                '.MuiDataGrid-columnSeparator': {
                  display: 'none',
                },
                '&.MuiDataGrid-root': {
                  border: 'none',
                },
                "& .MuiDialogContent-root": {
                  overflowY: "auto",
                  "::-webkit-scrollbar": {
                    width: "12px",
                  },
                  "::-webkit-scrollbar-track": {
                    background: theme.palette.text.disabled,
                  },
                  "::-webkit-scrollbar-thumb": {
                    background: theme.palette.background.paper,
                  },
                },
                color: "white",
                backgroundColor: theme.palette.secondary.accent,
              }}
              rows={
                result?.data?.result?.content?.slice(0, 5).sort((a, b) => {
                  // Priority 1: Sort by status "Ongoing" first
                  if (a.status === "ONGOING" && b.status !== "ONGOING") return -1;
                  if (a.status !== "ONGOING" && b.status === "ONGOING") return 1;

                  // Priority 2: Sort by createdDate (newest first)
                  return new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime();
                }).map((content, idx) => {
                  return {
                    ...content,
                    createdDate: format(
                      new Date(content?.createdDate),
                      "dd-MM-yyyy"
                    ),
                    id: idx + 1,
                  };
                }) || []
              }
              columns={[
                {
                  field: "createdDate",
                  headerName: t("walletcard.walletpage.period"),
                  width: 150,
                  editable: false,
                },
                {
                  field: "title",
                  headerName: t("walletcard.withdrawalpage.title"),
                  width: 150,
                  editable: false,
                },
                {
                  field: "validTurnOver",
                  headerName: t("walletcard.withdrawalpage.validbet"),
                  width: 150,
                  editable: false,
                },
                {
                  field: "turnover",
                  headerName: t("walletcard.withdrawalpage.validbetcondition"),
                  width: 150,
                  editable: false,
                },
                {
                  field: "status",
                  headerName: t("walletcard.walletpage.status"),
                  width: 150,
                  editable: false,
                }
              ]}
              hideFooter={true}
              rowsPerPageOptions={[5]}
              // checkboxSelection
              // disableSelectionOnClick
              // isCellEditable={false}
              onPageChange={(newPage) => setOffset(newPage)}
            />
          </Box>
          <Stack mt={2} spacing={2} size="small" alignItems="center">
            <Pagination
              // disabled={selectedAnnouncement.selected ? true : false}
              // onChange={handlePageChange}
              onChange={handlePageChange}
              count={
                result?.data?.result?.totalPages === 0
                  ? 1
                  : result?.data?.result?.totalPages
              }
              shape="rounded"
              sx={{
                "& .MuiPaginationItem-root": {
                  color: process.env.REACT_APP_COLOR_PAGINATION_WALLET_NUMBER2 || process.env.REACT_APP_COLOR_PAGINATION_NUMBER2 || "white",
                  "&.Mui-selected": {
                    background: lighten(
                      process.env.REACT_APP_COLOR_PAGINATION || theme.palette.background.paper,
                      0.02
                    ),
                    color: process.env.REACT_APP_COLOR_PAGINATION_WALLET_NUMBER1 || process.env.REACT_APP_COLOR_PAGINATION_NUMBER1 || "white",
                  },
                },
                "& .MuiPaginationItem-icon": {
                  color: process.env.REACT_APP_COLOR_PAGINATION_WALLET_NUMBER2 || process.env.REACT_APP_COLOR_PAGINATION_NUMBER2 || "white",
                },
              }}
            />
          </Stack>
        </>
      )}
      {!showWithdrawalComponents && (
        <>
          {mobileView && result?.data?.result?.content && result?.data?.result?.content?.slice(0, 5).sort((a, b) => {
            // Priority 1: Sort by status "Ongoing" first
            if (a.status === "ONGOING" && b.status !== "ONGOING") return -1;
            if (a.status !== "ONGOING" && b.status === "ONGOING") return 1;

            // Priority 2: Sort by createdDate (newest first)
            return new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime();
          }).map((content, idx) => (
            <Box key={idx} sx={{border: `1px solid ${process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || 'white'}`}} marginTop="10px">
              <Button
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}
                onClick={() => toggleOpenState(idx)}
              >
                <div>
                  <Typography sx={{ fontSize: '10px', color: process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || 'white', textAlign: 'left' }}>
                    {new Date(content.createdDate).toLocaleDateString(undefined, {
                      year: 'numeric',
                      month: 'short',
                      day: '2-digit',
                    })}
                  </Typography>
                  <Typography sx={{ fontSize: '11px', color: process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || 'white', fontWeight: 'bold' }}>
                    {content.title}
                  </Typography>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', width: '80px', height: '30px', backgroundColor: '#838383', lineHeight: '40px', padding: '5px', borderRadius: '5px' }}>
                  <Typography sx={{ color: 'white', textAlign: 'center', fontSize: '10px' }}>
                    {content.status}
                  </Typography>
                </div>
              </Button>
              <FocusTrap key={idx} open={openStates[idx]} disableRestoreFocus disableAutoFocus>
                <Stack alignItems="center" spacing={2}>
                  {openStates[idx] ? (
                    <Divider sx={{ backgroundColor: 'white', width: '100%' }} />
                  ) : (
                    <Button disabled={isLoading} onClick={() => toggleOpenState(idx)}>
                      <Typography sx={{ fontSize: '11px', color: process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || 'white', fontWeight: 'bold' }}>
                        More
                      </Typography>
                    </Button>
                  )}
                  {openStates[idx] && (
                    <Grid container >
                      <Grid item xs={6}>
                        <Typography sx={{ fontSize: '10px', color: process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || 'white', paddingLeft: '8px' }}>{t("walletcard.withdrawalpage.deposit")}</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography sx={{ fontSize: '10px', color: process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || 'white', paddingRight: '8px' }} align="right">{process.env.REACT_APP_CURRENCY_CODE} {content.deposit}</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography sx={{ fontSize: '10px', color: process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || 'white', paddingLeft: '8px' }}>{t("walletcard.withdrawalpage.title")}</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography sx={{ fontSize: '10px', color: process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || 'white', paddingRight: '8px' }} align="right">{content.title}</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography sx={{ fontSize: '10px', color: process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || 'white', paddingLeft: '8px' }}>{t("walletcard.withdrawalpage.validbet")}</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography sx={{ fontSize: '10px', color: process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || 'white', paddingRight: '8px' }} align="right">{process.env.REACT_APP_CURRENCY_CODE} {content.validTurnOver}</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography sx={{ fontSize: '10px', color: process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || 'white', paddingLeft: '8px', paddingBottom: '6px' }}>{t("walletcard.withdrawalpage.validbetcondition")}</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography sx={{ fontSize: '10px', color: process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || 'white', paddingRight: '8px', paddingBottom: '6px' }} align="right">{process.env.REACT_APP_CURRENCY_CODE} {content.turnover}</Typography>
                      </Grid>
                    </Grid>
                  )}
                </Stack>
              </FocusTrap>
            </Box>
          ))
          }
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Box alignItems="center" mb="30px" mt="30px">
              <Button variant="contained" disabled={isLoading} onClick={handleWithdrawButtonClick}>
                {t("walletcard.withdraw")}
              </Button>
            </Box>
          </div>
        </>
      )}
      {showWithdrawalComponents && (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <Box
                border={1}
                borderRadius={1}
                padding={1}
                borderColor="primary.main"
                width="100%"
                backgroundColor={process.env.REACT_APP_COLOR_WITHDRAWAL_BALANCE_BACKGROUND || theme.palette.primary.main}
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid display={'flex'} justifyContent={'center'} item>
                    <PaidIcon color={process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || "white"} />
                  </Grid>
                  <Grid item>
                    <Typography color={process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || "white"}>{t("walletcard.withdrawalpage.withdrawalbalance")} :</Typography>
                  </Grid>
                  <Grid item>
                    <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || "white"}>{process.env.REACT_APP_CURRENCY_CODE} {withdrawDetails?.totalValidTurnOver || '0.00'}</Typography>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            {user?.maxWithdraw > 0 && (
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <Box
                border={1}
                borderRadius={1}
                padding={1}
                borderColor="primary.main"
                width="100%"
                backgroundColor={theme.palette.primary.main}
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid display={'flex'} justifyContent={'center'} item>
                    <ErrorIcon color={process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || "white"} />
                  </Grid>
                  <Grid item>
                    <Typography color={process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || "white"}>{t("walletcard.withdrawalpage.maxwithdraw", {defaultValue:"Max Withdraw"})} :</Typography>
                  </Grid>
                  <Grid item>
                    <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || "white"}>{process.env.REACT_APP_CURRENCY_CODE} {user?.maxWithdraw || '0.00'}</Typography>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            )}
            
              {/*
              //hide promotion balance
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <Box
                border={1}
                borderRadius={1}
                padding={1}
                borderColor="secondary.main" // Customize border color as needed
                width="100%"
                backgroundColor={theme.palette.secondary.accent}
              >
              
                <Grid container spacing={2} alignItems="center">
                  <Grid display={'flex'} justifyContent={'center'} item>
                    <CardGiftcardIcon color={process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || "white"} />
                  </Grid>
                  
                  <Grid item>
                    <Typography color={process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || "white"}>{t("walletcard.withdrawalpage.promotionbalance")}:</Typography>
                  </Grid>
                 
                  <Grid item>
                    <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || "white"}>{process.env.REACT_APP_CURRENCY_CODE} {withdrawDetails?.totalPromotionBalance || '0.00'}</Typography>
                  </Grid>
                </Grid>
                 
              </Box>
            </Grid>
             */}
          </Grid>
          <br />
          <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || "white"}>
            {t("walletcard.withdrawaloption")}
          </Typography>
          <Box px={1}>
            <Tabs
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              onChange={handleTabChange}
              sx={{
                marginLeft: "1px"
              }}
            >
              {withdrawalType.map((type, index) => (
                <Tab
                  icon={
                    <Image
                      width="40px"
                      height="40px"
                      src={process.env.REACT_APP_PROFILE + `/payment_method_` + index + `.png`}
                    />}
                  key={index}
                  label={type.label}
                  sx={{
                    color: theme.palette.primary.main,
                    border:
                      index === tabValue && `2px solid ${theme.palette.primary.main}` ||
                      index !== tabValue && `1px solid ${theme.palette.button.faded.main}`,
                    fontWeight: 600,
                    borderRadius: "5px",
                    width: !mobileView ? "180px" : '50%',
                    padding: "10px 5px",
                    margin: "0  10px",
                    background: "rgba(255,255,255,0.25)"
                  }}
                  disableRipple
                />
              ))}
            </Tabs>
            <TabPanel value={tabValue} index={0}>
              <Box display="flex" flexDirection="column">
                <div style={{ display: 'flex', justifyContent: 'flex-end', fontSize: '2px', gap: '15px' }}>
                  <Button
                    variant="contained"
                    onClick={() => setSelectedScreen("Bank Account")}
                    sx={{
                      minWidth: '60px',
                      width: mobileView ? '30%' : 'auto',
                      height: "30px",
                      fontSize: '13px',
                      whiteSpace: 'nowrap' // Prevents text from wrapping
                    }}
                  >
                    {t("walletcard.withdrawalpage.addbank")}
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleClickOpen}
                    sx={{
                      minWidth: '110px',
                      width: mobileView ? '30%' : 'auto',
                      height: "30px",
                      fontSize: '13px',
                      whiteSpace: 'nowrap'  // Prevents text from wrapping
                    }}
                  >
                    {t("walletcard.withdrawalpage.selectbank")}
                  </Button>
                </div>
                <SimpleDialog
                  bankaccountname={bankAccountName}
                  open={open}
                  onClose={handleClose}
                />
                <form onSubmit={handleSubmit(submitWithdrawal)}>
                  <FormTextField
                    label={t("walletcard.withdrawalpage.bankname")}
                    control={control}
                    controllerName="bankCode"
                    items={withdrawDetails?.banks
                      ?.filter((item) => item.status === "ACTIVE")
                      .map((item) => item.content)}
                    size="small"
                    disabled={true}
                    dynamicValue={bankCode}
                    defaultValue={bankCode}
                  />
                  {bankCode === "ESEWA" && (
                    <Typography color={process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || "white"} variant="body2">
                      {t("walletcard.withdrawalpage.esewaWarning")}<br />
                      {t("walletcard.withdrawalpage.esewaWarning2")}
                    </Typography>
                  )}
                  <FormTextField
                    label={t("walletcard.withdrawalpage.bankaccountname")}
                    control={control}
                    controllerName="bankAccountName"
                    disabled={true}
                    size="small"
                    dynamicValue={bankAccountName}
                    defaultValue={bankAccountName}

                  />
                  <FormTextField
                    label={t("walletcard.withdrawalpage.bankaccountnumber")}
                    control={control}
                    controllerName="bankAccountNo"
                    defaultValue={bankAccountNumber}
                    size="small"
                    disabled={true}
                    dynamicValue={bankAccountNumber}
                  />
                  <FormTextField
                    label={t("walletcard.withdrawalpage.amount")}
                    control={control}
                    controllerName="amount"
                    defaultValue={""}
                    placeholder={`Min ${withdrawDetails?.withdrawalDetails?.minimum || 50.00}`}
                    size="small"
                  />
                  <Box alignSelf="center" mb="30px" mt="30px">
                    <Button variant="contained" type="submit" disabled={isLoading}>
                      {t("walletcard.submit")}
                    </Button>
                  </Box>
                </form>
                <Container sx={{ border: '1px solid #ccc', borderRadius: 4, padding: 2 }}>
                  <Typography color={theme.palette.secondary.accent}>
                    {t("walletcard.withdrawalpage.withdrawalLimit")}
                  </Typography>
                  {withdrawalLimit.map((item, index) => (
                    <Grid container key={index} spacing={2} >
                      <Grid item xs={6}>
                        <Typography color={process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || "white"}>{item.label}</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography color={process.env.REACT_APP_COLOR_WALLET_TEXT || process.env.REACT_APP_COLOR_TEXT || "white"} align="right">{item.value}</Typography>
                      </Grid>
                    </Grid>
                  ))}
                </Container>
              </Box>
            </TabPanel>
          </Box>
        </>
      )}
    </Container>
  );
};

export default Withdrawal;
